import { Box, Card, CardContent, CardHeader, Grid, IconButton, Typography } from "@mui/material";
import ViewCad from "../../../config/view";
import { isEmpty } from "../../../services/utils";
import { PacienteViewProps } from "../paciente.controller";
import { initialValuePaciente, Paciente } from "../paciente.model";
import { ContentForm } from "../../../components/viewCadastro/formCad";
import { ToolbarCad, ToolbarList } from "../../../components/toolbar";
import { Search } from "@mui/icons-material";
import { ViewSelecionarMedico,handleShowSelecionarMedico  } from "../../medico/view/medico.select";
import { Medico } from "../../medico/medico.model";

interface PacienteCadastroProps extends PacienteViewProps {
    handleCloseView: () => any
}

export function PacienteCadastro(props: PacienteCadastroProps) {
    const { pacienteActions, pacienteState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = pacienteState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = pacienteActions

    console.log("PacienteCadastro props", props)
    const handleNovo = () => {
        set({
            ...initialValuePaciente,
            dt_hr_chegada: new Date().toISOString()
        })
        handleShowSelecionarMedico(true)
    }

    const handleExcluir = (row: Paciente) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Paciente) => {
        const errors: any = { atendimento: { medico: {} }, }
        if (!values.nome)
            errors.nome = "Informe o nome do Paciente"
        return errors
    }

    const handleUpdate = (value: Paciente) => {
        console.log("handleupdate", value)
        if(isEmpty(value.atendimento.medico._id)){
            alert("Informe o profissional que irá atender o paciente!");
            return 
        }
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value)
    }

    var viewCad = new ViewCad({
        formTitle: "Informações sobre o atendimento",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar paciente a ser atendido",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        handleMutator: handleMutator,
        contentForm: [
            { fieldName: "dt_hr_chegada", label: "Data Chegada", type: "data", colunsXS: 12, colunsSM: 4, colunsMD: 4, require: true, tip: "Data e horario que o paciente foi recepcionado.", disabled: true },
            { fieldName: "dt_hr_chamada", label: "Hora Atendimento", type: "data", colunsXS: 12, colunsSM: 4, colunsMD: 4, require: true, tip: "Data e horario que o paciente foi atendido.", disabled: true, hidden: (value) => isEmpty(value.dt_hr_chamada) },
            { fieldName: "dt_hr_saida", label: "Hora Saída", type: "data", colunsXS: 12, colunsSM: 4, colunsMD: 4, require: true, tip: "Data e horario que o atendimento foi finalizado.", disabled: true, hidden: (value) => isEmpty(value.dt_hr_saida) },
            { fieldName: "nome", label: "Nome do Paciente", type: "text", key: "nome", colunsXS: 12, colunsSM: 8, colunsMD: 8, require: true },
            { fieldName: "situacao", label: "Situação", type: "chip", colunsXS: 12, colunsSM: 4, colunsMD: 4 },
            { fieldName: "atendimento", label: "", type: "text", key: "atendimento", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true, hidden: () => true },
            { fieldName: "atendimento.medico", label: "", type: "text", key: "medico", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true, hidden: () => true },

        ],
        ContentBox: (props) => {
            const { form, values } = props!
            return (
                <Box sx={{ display: "flex", flex: 1 }}>
                    <Card sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                        <CardHeader
                            title={
                                <Typography>Informe o profissional</Typography>
                            }
                            avatar={
                                <IconButton
                                    title="Localizar profissional"
                                    onClick={() => handleShowSelecionarMedico(true)}
                                >
                                    <Search />
                                </IconButton>
                            }
                        />
                        <CardContent>
                            <Grid container spacing={2}>
                                <ContentForm fieldName={"atendimento.medico.nome"} type="text" label="Medico" colunsXS={12} colunsSM={6} colunsMD={6} disabled={true} require />
                                <ContentForm fieldName={"atendimento.medico.especialidade"} type="text" label="Especialidade" colunsXS={12} colunsSM={6} colunsMD={6} disabled={true} require />                                
                            </Grid>
                        </CardContent>
                    </Card>
                    <ViewSelecionarMedico
                        handleConfirmar={(row) => {
                            let medico: any = {
                                _id: row._id,
                                nome: row.nome,
                                especialidade:row.especialidade
                            }
                            let atendPaciente: any = {
                                _id: "",
                                sala_desc: "",
                                medico: medico
                            }                            
                            form.mutators.handleMutator(atendPaciente, "atendimento")
                            handleShowSelecionarMedico(false);
                        }}
                        

                    />

                </Box>
            )
        }
    })

    return viewCad
}



